import React from 'react'

import { AppRetailerBlock } from "@components"
import { Box } from "@mui/material"


export default function idMainSiteColumn() {

	return {
		name: "mainSite", label: "Main Site", options: {
			customBodyRowRenderLite: (value, { mainSiteMarket }) => <Box
				sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<AppRetailerBlock
					sx={{
						'& .MuiTypography-root': {
							fontWeight: 'bold',
						}
					}}
					country={mainSiteMarket}
					retailer={value}
				/>
			</Box>
		}
	}

}